import { Navigate } from 'react-router-dom'

export default function Home() {
  Navigate({ to: '/account' })
}
